// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root, :host {
  --rc-popup-title-fontFamily: "Manrope", sans-serif;
  --rc-popup-title-fontWeight: 800;
  --rc-popup-title-fontSize: 21px;
  --rc-popup-title-lineHeight: 30px;

  --rc-popup-full-veil-bgColor: #ffffff;
  --rc-popup-modal-veil-bgColor: rgba(52,59,76, 0.9);
  --rc-popup-bgColor: #ffffff;
  --rc-popup-borderRadius: 15px;
  --rc-popup-boxShadow: 0px 10px 30px -5px rgba(49,94,251, 0.25);
  --rc-popup-color: #343b4c;
  --rc-popup-hover-color: #2c54e2;
  --rc-popup-active-color: #274bc8;
  }

:root.dark-mode {
  --rc-popup-full-veil-bgColor: #1f2431;
  --rc-popup-modal-veil-bgColor: rgba(52,59,76, 0.9);
  --rc-popup-bgColor: #1f2431;
  --rc-popup-boxShadow: 0px 10px 30px -5px rgba(13,16,23, 0.6);
  --rc-popup-color: #eff5ff;
  --rc-popup-hover-color: #a2c4ff;
  --rc-popup-active-color: #83b1ff;
  }

.rc__4ybqsd,
.rc__3q2t75 {
  position: fixed;
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-overflow-scrolling: touch;
  z-index: 100;
}

.rc__4ybqsd {
  background-color: var(--rc-popup-full-veil-bgColor);
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 100ms, transform 100ms;
}

.rc__4ybqsd.rc__7rrarf {
    opacity: 1;
    transform: scale(1);
  }

.rc__3q2t75 {
  background-color: var(--rc-popup-modal-veil-bgColor);
  opacity: 0;
  transition: opacity 100ms;
}

.rc__3q2t75.rc__7rrarf {
    opacity: 1;
  }

.rc__3q2t75 .rc__4eupun {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    width: -moz-fit-content;
    width: fit-content;
    min-width: 100%;
    min-height: 100%;
    padding: 50px;
  }

@media (max-width: 768px) {

.rc__3q2t75 .rc__4eupun {
      padding: 10px
  }
    }

.rc__475vn5 {
  outline: none;
}

.rc__4ybqsd .rc__475vn5 {
    width: 100%;
    height: 100%;
    background: var(--rc-popup-bgColor);
  }

.rc__3q2t75 .rc__475vn5 {
    position: relative;
    max-width: 100%;
    border-radius: var(--rc-popup-borderRadius);
    background: var(--rc-popup-bgColor);
    transform: translateY(20px);
    transition: transform 100ms;
  }

.rc__3q2t75.rc__7rrarf .rc__475vn5 {
    transform: translateY(0);
  }

.rc__3q2t75.rc__pndd7k .rc__475vn5 {
    transform: translateY(-20px);
  }

.rc__3c6y1a {
  margin: 0 20px 15px;
  padding-top: 20px;
  font-family: var(--rc-popup-title-fontFamily);
  font-weight: var(--rc-popup-title-fontWeight);
  font-size: var(--rc-popup-title-fontSize);
  line-height: var(--rc-popup-title-lineHeight);
  color: var(--rc-popup-color);
}

.rc__3c6y1a.rc__3eh8nt {
    padding-right: 40px;
  }

.rc__7cnme8 {
  padding: 0;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  cursor: pointer;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  color: var(--rc-popup-color);
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  z-index: 1;
}

.rc__4ybqsd .rc__7cnme8 {
    right: 20px;
    top: 20px;
  }

.rc__3q2t75 .rc__7cnme8 {
    right: 10px;
    top: 10px;
  }

@media (hover: hover) {

.rc__7cnme8 {
    transition: color 200ms
}

    .rc__7cnme8:hover {
      color: var(--rc-popup-hover-color);
    }
  }

.rc__7cnme8:active {
    color: var(--rc-popup-active-color);
  }

.rc__yz4apd {
  display: block;
  width: 30px;
  height: 30px;
}

.rc__743s1x {
  margin: 0 20px 20px;
  padding-top: 20px;
}

.rc__3c6y1a ~ .rc__743s1x {
    padding-top: 0;
  }

`, "",{"version":3,"sources":["webpack://./node_modules/@rambler-components/popup/styles.css"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;;EAEjC,qCAAqC;EACrC,kDAAkD;EAClD,2BAA2B;EAC3B,6BAA6B;EAC7B,8DAA8D;EAC9D,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC;;AAEF;EACE,qCAAqC;EACrC,kDAAkD;EAClD,2BAA2B;EAC3B,4DAA4D;EAC5D,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC;;AAEF;;EAEE,eAAe;EACf,cAAc;EACd,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,UAAU;EACV,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;IACI,UAAU;IACV,mBAAmB;EACrB;;AAEF;EACE,oDAAoD;EACpD,UAAU;EACV,yBAAyB;AAC3B;;AAEA;IACI,UAAU;EACZ;;AAEF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;;AAEF;;AAEA;MACM;EACJ;IACE;;AAEJ;EACE,aAAa;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;EACrC;;AAEF;IACI,kBAAkB;IAClB,eAAe;IACf,2CAA2C;IAC3C,mCAAmC;IACnC,2BAA2B;IAC3B,2BAA2B;EAC7B;;AAEF;IACI,wBAAwB;EAC1B;;AAEF;IACI,4BAA4B;EAC9B;;AAEF;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;EAC7C,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;IACI,mBAAmB;EACrB;;AAEF;EACE,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;;EAEf,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,UAAU;AACZ;;AAEA;IACI,WAAW;IACX,SAAS;EACX;;AAEF;IACI,WAAW;IACX,SAAS;EACX;;AAEF;;AAEA;IACI;AACJ;;IAEI;MACE,kCAAkC;IACpC;EACF;;AAEF;IACI,mCAAmC;EACrC;;AAEF;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;IACI,cAAc;EAChB","sourcesContent":[":root, :host {\n  --rc-popup-title-fontFamily: \"Manrope\", sans-serif;\n  --rc-popup-title-fontWeight: 800;\n  --rc-popup-title-fontSize: 21px;\n  --rc-popup-title-lineHeight: 30px;\n\n  --rc-popup-full-veil-bgColor: #ffffff;\n  --rc-popup-modal-veil-bgColor: rgba(52,59,76, 0.9);\n  --rc-popup-bgColor: #ffffff;\n  --rc-popup-borderRadius: 15px;\n  --rc-popup-boxShadow: 0px 10px 30px -5px rgba(49,94,251, 0.25);\n  --rc-popup-color: #343b4c;\n  --rc-popup-hover-color: #2c54e2;\n  --rc-popup-active-color: #274bc8;\n  }\n\n:root.dark-mode {\n  --rc-popup-full-veil-bgColor: #1f2431;\n  --rc-popup-modal-veil-bgColor: rgba(52,59,76, 0.9);\n  --rc-popup-bgColor: #1f2431;\n  --rc-popup-boxShadow: 0px 10px 30px -5px rgba(13,16,23, 0.6);\n  --rc-popup-color: #eff5ff;\n  --rc-popup-hover-color: #a2c4ff;\n  --rc-popup-active-color: #83b1ff;\n  }\n\n.rc__4ybqsd,\n.rc__3q2t75 {\n  position: fixed;\n  overflow: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -webkit-overflow-scrolling: touch;\n  z-index: 100;\n}\n\n.rc__4ybqsd {\n  background-color: var(--rc-popup-full-veil-bgColor);\n  opacity: 0;\n  transform: scale(0.95);\n  transition: opacity 100ms, transform 100ms;\n}\n\n.rc__4ybqsd.rc__7rrarf {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n.rc__3q2t75 {\n  background-color: var(--rc-popup-modal-veil-bgColor);\n  opacity: 0;\n  transition: opacity 100ms;\n}\n\n.rc__3q2t75.rc__7rrarf {\n    opacity: 1;\n  }\n\n.rc__3q2t75 .rc__4eupun {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: -moz-fit-content;\n    width: fit-content;\n    min-width: 100%;\n    min-height: 100%;\n    padding: 50px;\n  }\n\n@media (max-width: 768px) {\n\n.rc__3q2t75 .rc__4eupun {\n      padding: 10px\n  }\n    }\n\n.rc__475vn5 {\n  outline: none;\n}\n\n.rc__4ybqsd .rc__475vn5 {\n    width: 100%;\n    height: 100%;\n    background: var(--rc-popup-bgColor);\n  }\n\n.rc__3q2t75 .rc__475vn5 {\n    position: relative;\n    max-width: 100%;\n    border-radius: var(--rc-popup-borderRadius);\n    background: var(--rc-popup-bgColor);\n    transform: translateY(20px);\n    transition: transform 100ms;\n  }\n\n.rc__3q2t75.rc__7rrarf .rc__475vn5 {\n    transform: translateY(0);\n  }\n\n.rc__3q2t75.rc__pndd7k .rc__475vn5 {\n    transform: translateY(-20px);\n  }\n\n.rc__3c6y1a {\n  margin: 0 20px 15px;\n  padding-top: 20px;\n  font-family: var(--rc-popup-title-fontFamily);\n  font-weight: var(--rc-popup-title-fontWeight);\n  font-size: var(--rc-popup-title-fontSize);\n  line-height: var(--rc-popup-title-lineHeight);\n  color: var(--rc-popup-color);\n}\n\n.rc__3c6y1a.rc__3eh8nt {\n    padding-right: 40px;\n  }\n\n.rc__7cnme8 {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n  box-shadow: none;\n  cursor: pointer;\n\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  color: var(--rc-popup-color);\n  transform: translate3d(0, 0, 0);\n  cursor: pointer;\n  z-index: 1;\n}\n\n.rc__4ybqsd .rc__7cnme8 {\n    right: 20px;\n    top: 20px;\n  }\n\n.rc__3q2t75 .rc__7cnme8 {\n    right: 10px;\n    top: 10px;\n  }\n\n@media (hover: hover) {\n\n.rc__7cnme8 {\n    transition: color 200ms\n}\n\n    .rc__7cnme8:hover {\n      color: var(--rc-popup-hover-color);\n    }\n  }\n\n.rc__7cnme8:active {\n    color: var(--rc-popup-active-color);\n  }\n\n.rc__yz4apd {\n  display: block;\n  width: 30px;\n  height: 30px;\n}\n\n.rc__743s1x {\n  margin: 0 20px 20px;\n  padding-top: 20px;\n}\n\n.rc__3c6y1a ~ .rc__743s1x {\n    padding-top: 0;\n  }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
